import { lazy } from 'react';

const LiveCasinoRoutes = lazy(() =>
	import(
		/* webpackChunkName: "live-casino-routes" */
		'./live-casino-routes.js'
	)
);

export default LiveCasinoRoutes;
